var map = {
	"./brand-story-arrow1.png": 332,
	"./brand-story-arrow2.png": 333,
	"./brand-story-banner1.jpg": 334,
	"./brand-story-banner1.png": 335,
	"./brand-story-banner2.png": 336,
	"./brand-story-img1.png": 337,
	"./brand-story-img2.png": 131,
	"./brand-story-img3.png": 132,
	"./brand-story-img4.png": 133,
	"./brand-story-meaning-bg.png": 338,
	"./brand-story-meaning-ico-line.png": 339,
	"./brand-story-meaning-ico1-1.png": 340,
	"./brand-story-meaning-ico1-2.png": 341,
	"./brand-story-meaning-ico10-1.png": 342,
	"./brand-story-meaning-ico10-2.png": 343,
	"./brand-story-meaning-ico11-1.png": 344,
	"./brand-story-meaning-ico11-2.png": 345,
	"./brand-story-meaning-ico12-1.png": 346,
	"./brand-story-meaning-ico12-2.png": 347,
	"./brand-story-meaning-ico2-1.png": 348,
	"./brand-story-meaning-ico2-2.png": 349,
	"./brand-story-meaning-ico3-1.png": 350,
	"./brand-story-meaning-ico3-2.png": 351,
	"./brand-story-meaning-ico4-1.png": 352,
	"./brand-story-meaning-ico4-2.png": 353,
	"./brand-story-meaning-ico5-1.png": 354,
	"./brand-story-meaning-ico5-2.png": 355,
	"./brand-story-meaning-ico6-1.png": 356,
	"./brand-story-meaning-ico6-2.png": 357,
	"./brand-story-meaning-ico7-1.png": 358,
	"./brand-story-meaning-ico7-2.png": 359,
	"./brand-story-meaning-ico8-1.png": 360,
	"./brand-story-meaning-ico8-2.png": 361,
	"./brand-story-meaning-ico9-1.png": 362,
	"./brand-story-meaning-ico9-2.png": 363,
	"./brand-story-meaning1.png": 364,
	"./brand-story-meaning10.png": 365,
	"./brand-story-meaning11.png": 366,
	"./brand-story-meaning12.png": 367,
	"./brand-story-meaning2.png": 368,
	"./brand-story-meaning3.png": 369,
	"./brand-story-meaning4.png": 370,
	"./brand-story-meaning5.png": 371,
	"./brand-story-meaning6.png": 372,
	"./brand-story-meaning7.png": 373,
	"./brand-story-meaning8.png": 374,
	"./brand-story-meaning9.png": 375,
	"./brand-story-wap-ico.png": 376,
	"./brand-story-wap1.jpg": 377,
	"./brand-story-wap10.jpg": 378,
	"./brand-story-wap2.jpg": 379,
	"./brand-story-wap3.jpg": 380,
	"./brand-story-wap4.jpg": 381,
	"./brand-story-wap5.jpg": 382,
	"./brand-story-wap6.jpg": 383,
	"./brand-story-wap7.jpg": 384,
	"./brand-story-wap8.jpg": 385,
	"./brand-story-wap9.jpg": 386,
	"./business-philosophy-ad1.jpg": 134,
	"./business-philosophy-ad1.png": 135,
	"./business-philosophy-banner1.png": 387,
	"./business-philosophy-img1.png": 99,
	"./company-profile-ad1.jpg": 136,
	"./company-profile-ad1.png": 388,
	"./company-profile-ad2.png": 389,
	"./company-profile-ad3.png": 390,
	"./company-profile-ad4.png": 391,
	"./company-profile-ad5.png": 392,
	"./company-profile-banner1.png": 393,
	"./company-profile-banner2.png": 394,
	"./company-profile-banner3.png": 395,
	"./company-profile-bg.jpg": 137,
	"./company-profile-bg1.png": 396,
	"./company-profile-bg2.jpg": 397,
	"./company-profile-ico1.png": 398,
	"./company-profile-ico2.jpg": 399,
	"./company-share-arrow.png": 100,
	"./cooking-salon-ad1.png": 138,
	"./cooking-salon-ad2.jpg": 101,
	"./cooking-salon-ad2.png": 400,
	"./cooking-salon-ad3.jpg": 139,
	"./cooking-salon-ad3.png": 401,
	"./cooking-salon-ad4.jpg": 102,
	"./cooking-salon-ad5.jpg": 140,
	"./cooking-salon-banner1.png": 402,
	"./entrepreneurial-platform-ad1.png": 141,
	"./entrepreneurial-platform-ad2.png": 403,
	"./entrepreneurial-platform-ad3.png": 404,
	"./entrepreneurial-platform-banner1.png": 405,
	"./features-surface-ad1.png": 406,
	"./features-surface-ad2.png": 407,
	"./features-surface-ad3.png": 408,
	"./features-surface-ad4.png": 409,
	"./features-surface-ad5.png": 410,
	"./features-surface-ad6.png": 411,
	"./features-surface-ico1.png": 412,
	"./features-surface-ico10.png": 413,
	"./features-surface-ico2.png": 414,
	"./features-surface-ico3.png": 415,
	"./features-surface-ico4.png": 416,
	"./features-surface-ico5.png": 417,
	"./features-surface-ico6.png": 418,
	"./features-surface-ico7.png": 419,
	"./features-surface-ico8.png": 420,
	"./features-surface-ico9.png": 421,
	"./footer-arrow-ico.png": 422,
	"./footer-arrow-ico2.png": 423,
	"./footer-arrow-ico2.svg": 40,
	"./footer-bg.jpg": 424,
	"./footer-bg2.png": 425,
	"./footer-ico1.png": 426,
	"./footer-ico1.svg": 427,
	"./footer-ico2.png": 428,
	"./footer-ico2.svg": 429,
	"./footer-ico3.png": 430,
	"./footer-ico3.svg": 431,
	"./footer-ico4.png": 432,
	"./footer-ico4.svg": 433,
	"./footer-ico5.png": 434,
	"./footer-ico5.svg": 435,
	"./footer-ico6.png": 436,
	"./footer-ico6.svg": 437,
	"./footer-phone-ico.png": 438,
	"./fresh-factory-ad1.png": 142,
	"./fresh-factory-ad2.png": 439,
	"./fresh-factory-ad3.png": 440,
	"./fresh-factory-ad4.png": 441,
	"./fresh-factory-ad5.png": 442,
	"./fresh-factory-ad6.png": 143,
	"./fresh-factory-ad7.png": 144,
	"./fresh-factory-banner1.jpg": 443,
	"./fresh-factory-banner1.png": 444,
	"./fresh-factory-banner2.png": 445,
	"./fresh-factory-banner4.png": 446,
	"./fresh-factory-img1.png": 145,
	"./fresh-factory-img10.png": 447,
	"./fresh-factory-img11.png": 448,
	"./fresh-factory-img12.png": 449,
	"./fresh-factory-img13.png": 450,
	"./fresh-factory-img2.png": 146,
	"./fresh-factory-img3.png": 147,
	"./fresh-factory-img4.png": 148,
	"./fresh-factory-img5.png": 149,
	"./fresh-factory-img6.png": 451,
	"./fresh-factory-img7.png": 452,
	"./fresh-factory-img8.png": 453,
	"./fresh-factory-img9.png": 454,
	"./han-taste-ad1.jpg": 455,
	"./han-taste-ad1.png": 456,
	"./han-taste-ad10.png": 457,
	"./han-taste-ad11.png": 458,
	"./han-taste-ad2.jpg": 459,
	"./han-taste-ad2.png": 460,
	"./han-taste-ad3.jpg": 461,
	"./han-taste-ad3.png": 462,
	"./han-taste-ad4.jpg": 463,
	"./han-taste-ad4.png": 464,
	"./han-taste-ad5.png": 150,
	"./han-taste-ad6.png": 151,
	"./han-taste-ad7.png": 465,
	"./han-taste-ad8.png": 466,
	"./han-taste-ad9.png": 467,
	"./han-taste-banner1.png": 468,
	"./han-taste-banner2.png": 469,
	"./han-taste-bg1.png": 470,
	"./han-taste-bg2.png": 471,
	"./han-taste-snacks-ad1.png": 472,
	"./han-taste-snacks-ad2.png": 473,
	"./head-logo.png": 96,
	"./head-logo_20230515.png": 474,
	"./head-nav-ico1.png": 475,
	"./head-nav-ico2.png": 476,
	"./head-phone.png": 477,
	"./honor-bg1.png": 478,
	"./honor-bg2.png": 479,
	"./honor-bg3.png": 480,
	"./honor-img1.png": 152,
	"./honor-img2.png": 153,
	"./honor-img3.png": 154,
	"./honor-img4.png": 155,
	"./honor-img5.png": 481,
	"./honor-img6.png": 482,
	"./honor-img7.png": 483,
	"./honor-img8.png": 484,
	"./honor-img9.png": 485,
	"./hot-noodles-ad1.png": 156,
	"./hot-noodles-ad2.png": 157,
	"./hot-noodles-ad3.png": 158,
	"./hot-noodles-ad4.png": 159,
	"./hot-noodles-ad5.png": 160,
	"./hot-noodles-ad6.png": 161,
	"./hot-noodles-ad7.png": 486,
	"./hot-noodles-ad8.png": 487,
	"./hot-noodles-arrow1.png": 488,
	"./hot-noodles-arrow2.png": 489,
	"./hot-noodles-banner1.png": 490,
	"./hot-noodles-banner2.png": 491,
	"./hot-noodles-bg.jpg": 492,
	"./hot-noodles-ico1.png": 493,
	"./hot-noodles-ico2.png": 162,
	"./hot-noodles-img.jpg": 494,
	"./index-ad-img1.jpg": 495,
	"./index-ad-img2.jpg": 496,
	"./index-ad-img3-2.jpg": 163,
	"./index-ad-img3-3.png": 164,
	"./index-ad-img3.jpg": 165,
	"./index-ad-img4.jpg": 497,
	"./index-ad-img4.png": 498,
	"./index-ad-img5.jpg": 499,
	"./index-ad-img5.png": 500,
	"./index-ad-img6.jpg": 501,
	"./index-banner.png": 502,
	"./index-banner2.png": 503,
	"./index-cover.png": 504,
	"./index-qrcode.png": 103,
	"./index-qrcode2.png": 166,
	"./index-video-bg.png": 505,
	"./index-video-bg2.jpg": 506,
	"./index-video-heart.png": 507,
	"./index-video-heart2.png": 508,
	"./index-video-ico.png": 509,
	"./index-video-img1.png": 167,
	"./index-video-img2.png": 510,
	"./index-video-img3.png": 168,
	"./index-video-logo.png": 169,
	"./inherit-ico1.png": 511,
	"./inherit-ico2.png": 512,
	"./inherit-img1.png": 170,
	"./inherit-img2.png": 513,
	"./inherit-img3.png": 171,
	"./inherit-img4.png": 172,
	"./inherit-img5.png": 173,
	"./inherit-img6.png": 174,
	"./inherit-img7.png": 514,
	"./join-in-banner1.jpg": 515,
	"./join-in-banner1.png": 516,
	"./join-in-banner2.png": 517,
	"./join-in-ico2-1.png": 175,
	"./join-in-ico2-2.png": 176,
	"./join-in-ico2-3.png": 177,
	"./join-in-ico2-4.png": 178,
	"./join-in-icon1-1.png": 518,
	"./join-in-icon2-1.png": 519,
	"./join-in-icon3-1.png": 64,
	"./join-in-icon3-2.png": 520,
	"./join-in-icon3-3.png": 521,
	"./join-in-icon3-4.png": 522,
	"./join-in-icon3-5.png": 523,
	"./join-in-icon4-1.png": 524,
	"./join-in-icon4-2.png": 525,
	"./join-in-icon4-3.png": 526,
	"./join-in-icon4-4.png": 527,
	"./join-in-icon4-5.png": 528,
	"./join-in-icon4-6.png": 529,
	"./join-in-icon5-1.png": 530,
	"./join-in-icon5-2.png": 531,
	"./join-in-icon5-3.png": 532,
	"./join-in-icon5-4.png": 533,
	"./join-in-icon5-5.png": 534,
	"./join-in-icon7-1.png": 535,
	"./join-in-icon7-2.png": 536,
	"./join-in-img1-1.jpg": 537,
	"./join-in-img1-2.jpg": 538,
	"./join-in-img1-3.jpg": 539,
	"./join-in-img1-4.jpg": 540,
	"./join-in-img1-5.jpg": 541,
	"./join-in-img1-6.jpg": 542,
	"./join-in-img2-1.jpg": 543,
	"./join-in-img3-1.jpg": 179,
	"./join-in-img3-1.png": 544,
	"./join-in-img3-2.png": 180,
	"./join-in-img3-3.png": 181,
	"./join-in-img3-4.png": 182,
	"./join-in-img3-5.png": 183,
	"./join-in-img4-1.jpg": 545,
	"./join-in-img4-1.png": 184,
	"./join-in-img5-1.jpg": 546,
	"./join-in-img6-1.jpg": 547,
	"./join-in-img6-2.png": 548,
	"./join-in-img7-1.jpg": 549,
	"./join-in-img8-1.jpg": 550,
	"./join-in-img8-2.png": 551,
	"./join-in-img9-1.png": 552,
	"./join-in-line.png": 553,
	"./loading.png": 554,
	"./news-activity-banner1.jpg": 555,
	"./news-activity-banner1.png": 556,
	"./news-activity-banner2.png": 557,
	"./news-activity-banner3.png": 558,
	"./news-activity-img1.png": 559,
	"./news-details-ad.png": 560,
	"./news-details-banner.png": 561,
	"./online-registration-banner1.png": 562,
	"./online-registration-banner2.png": 563,
	"./online-registration-ico.png": 564,
	"./partner-story-ad1.jpg": 565,
	"./partner-story-ad1.png": 566,
	"./partner-story-ad2.jpg": 567,
	"./partner-story-ad3.jpg": 568,
	"./partner-story-ad4.jpg": 569,
	"./partner-story-banner1.png": 570,
	"./partner-story-ico1.png": 185,
	"./professional-teaching-ad1.png": 186,
	"./professional-teaching-ad2.png": 571,
	"./professional-teaching-ad3.png": 572,
	"./professional-teaching-ad4.png": 573,
	"./professional-teaching-ad5.png": 574,
	"./professional-teaching-ad6.png": 575,
	"./professional-teaching-banner1.png": 576,
	"./professional-teaching-banner2.png": 577,
	"./professional-teaching-ico1.png": 578,
	"./recruitment-ad1.png": 579,
	"./recruitment-ad2.png": 580,
	"./recruitment-banner1.png": 581,
	"./recruitment-banner2.png": 582,
	"./recruitment-img1.png": 187,
	"./recruitment-img2.png": 188,
	"./relationship-between-banner1.png": 583,
	"./relationship-between-banner2.png": 584,
	"./relationship-between-bg1.png": 585,
	"./relationship-between-bg2.png": 586,
	"./relationship-between-bg3.png": 587,
	"./relationship-between-bg4.png": 588,
	"./relationship-between-ico1-1.png": 589,
	"./relationship-between-ico1-2.png": 590,
	"./relationship-between-ico1.png": 591,
	"./relationship-between-ico2-1.png": 592,
	"./relationship-between-ico2-2.png": 593,
	"./relationship-between-ico2.png": 594,
	"./relationship-between-ico3-1.png": 595,
	"./relationship-between-ico3-2.png": 596,
	"./relationship-between-ico3.png": 597,
	"./relationship-between-ico4-1.png": 598,
	"./relationship-between-ico4-2.png": 599,
	"./relationship-between-ico4.png": 600,
	"./right-ico1.png": 601,
	"./right-ico1.svg": 189,
	"./right-ico2.png": 602,
	"./right-ico2.svg": 190,
	"./right-ico3.png": 603,
	"./right-ico3.svg": 191,
	"./right-wechat-bg.png": 604,
	"./school-ico1.png": 605,
	"./school-ico2.png": 606,
	"./school-ico3.png": 607,
	"./school-ico4.png": 608,
	"./school-img1.png": 609,
	"./school-img2.png": 610,
	"./school-img3.png": 611,
	"./school-img4.png": 612,
	"./school-img5.png": 613,
	"./school-profile-ad1.png": 192,
	"./school-profile-ad10.png": 614,
	"./school-profile-ad11.png": 615,
	"./school-profile-ad12.png": 616,
	"./school-profile-ad2.jpg": 193,
	"./school-profile-ad2.png": 617,
	"./school-profile-ad3.jpg": 194,
	"./school-profile-ad3.png": 618,
	"./school-profile-ad4.jpg": 195,
	"./school-profile-ad4.png": 619,
	"./school-profile-ad5.png": 620,
	"./school-profile-ad6.png": 621,
	"./school-profile-ad7.png": 622,
	"./school-profile-ad8.png": 623,
	"./school-profile-ad9.png": 624,
	"./school-profile-banner1.jpg": 625,
	"./school-profile-banner1.png": 626,
	"./school-profile-banner2.png": 627,
	"./school-profile-banner4.png": 628,
	"./school-profile-ico1.png": 629,
	"./school-profile-ico2.png": 196,
	"./school-profile-ico3.png": 197,
	"./school-profile-ico4.png": 198,
	"./school-top-ad.png": 630,
	"./store-display-banner4.png": 631,
	"./store-display-ico.png": 632,
	"./store-display-img1.png": 199,
	"./store-display-line.png": 200
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 27;